// extracted by mini-css-extract-plugin
export default {"dialog":"PaymentCompleteDialog_dialog__l2-2y","icon":"PaymentCompleteDialog_icon__dK9ba","formButton":"PaymentCompleteDialog_formButton__T+yum"};